import React from 'react';
import { Fade } from '@cleartrip/bento';

function Compressed({ active, children }) {
	return <Fade transition={{duration: 0.5}} pose={!active ? 'visible': 'hidden'}>{!active && children}</Fade>;
}

export default Compressed;
